import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import i18n from 'simple-react-i18n'
import { Button, Card, Grid, Stack, Tab, Tabs } from '@mui/material'
import useTitle from '../../../utils/customHook/useTitle'
import CodeChoicePanel from './CodeChoicePanel'
import NoteAddIcon from '@mui/icons-material/NoteAdd'
import { justsave, saveAndLaunch } from 'traitements/components/SaveTreatment'
import hydroPortailLogo from 'assets/pictures/logos/hydroportail.png'
import EtiagesOndeLogo from 'assets/pictures/logos/EtiagesOnde.png'
import shomLogo from 'assets/pictures/logos/shom.png'
import adesLogo from 'assets/pictures/logos/ades.png'
import naiadesLogo from 'assets/pictures/logos/naiades.png'
import orobnatLogo from 'assets/pictures/logos/orobnat.png'
import meteofranceLogo from 'assets/pictures/logos/meteofrance.png'
import era5Logo from 'assets/pictures/logos/era5.png'
import pluvioempriseLogo from 'assets/pictures/logos/pluvioemprise.png'
import safranLogo from 'assets/pictures/logos/safran.png'
import TraitementImportStartCard from './TraitementImportStartCard'
import { CITIES, IMPORT_TYPE } from 'traitements/constants/TraitementConstants'
import { StyledFieldSet, StyledLegend, StyledSpan } from 'components/StyledElements'
import CityAction from 'referencial/components/city/actions/CityAction'
import JobAction from 'import/actions/JobAction'
import TraitementSynchroStartCard from './TraitementSynchroStartCard'
import { entries, keys } from 'lodash'
import PlayCircleFilledWhiteOutlinedIcon from '@mui/icons-material/PlayCircleFilledWhiteOutlined'

const ID_JOB_MAX = -100
const ID_JOB_MIN = -111

const ImportStartApp = ({}) => {
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(CityAction.fetchCities())
    }, [dispatch])

    useTitle(() => [{
        title: i18n.administration,
        href: 'administration',
    }, {
        title: i18n.clientOnboarding,
        href: 'administration',
    }], [])


    const TRATEMENT_INDEX = 0
    const SYNCHRO_INDEX = 1
    const [tab, setTab] = useState(TRATEMENT_INDEX)
    const [pair, setPair] = useState({})
    const [pairToSave, setPairToSave] = useState({})
    const [pairToSaveSynchro, setPairToSaveSynchro] = useState({})
    const [choiceTypeCode, setChoiceTypeCode] = useState('')
    const [listCode, setListCode] = useState([])
    const [typeStation, setTypeStation] = useState([])
    const [type, settype] = useState([])
    const [listHour, setListHour] = useState([ 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17])

    useEffect(() => {
        dispatch(JobAction.fetchFullJobs())
    }, [])
    const jobs = useSelector(state => state.JobReducer.jobs)
    const activeJobs = jobs.filter(job => job.id >= ID_JOB_MIN && job.id <= ID_JOB_MAX)


    const changeName = (indice, valeur) => {
        setPair(prev => ({
            ...prev,
            [indice]: valeur,
        }))
    }

    const handleSaveAll = () => {
        if (keys(pairToSave).length > 0) {
            entries(pairToSave).forEach(([jobtype, data]) => {
                justsave(
                    data.listCode,
                    data.initialJob,
                    jobtype,
                    data.filters,
                    data.dispatch,
                )
            })
        } else {
            entries(pairToSaveSynchro).forEach(([jobtype, data]) => {
                justsave(
                    data.listCode,
                    data.initialJob,
                    jobtype,
                    data.filters,
                    data.dispatch,
                )
            })
        }

        setPairToSave({})
        setPair({})
        setTypeStation([])
    }

    const handleStartAndSaveAll = () => {
        if (keys(pairToSave).length > 0) {
            entries(pairToSave).forEach(([jobtype, data]) => {
                saveAndLaunch(
                    data.listCode,
                    data.initialJob,
                    jobtype,
                    data.filters,
                    data.dispatch,
                )
            })
        }

        setPairToSave({})
        setPair({})
        setTypeStation([])
    }


    const params = { listCode, choiceTypeCode, setChoiceTypeCode, setListCode, changeName, typeStation, setTypeStation, type, settype, pair, setPair, setPairToSave, listHour, setListHour }
    const paramsSynchro = { choiceTypeCode, setChoiceTypeCode, listCode, typeStation, pair, pairToSaveSynchro, setPairToSaveSynchro }
    return (
        <Grid spacing={4}>
            <Tabs
                value={tab}
                onChange={(_, newValue) => setTab(newValue)}
                variant='fullWidth'
            >
                <Tab label={ i18n.addTreatmentStart } />
                <Tab label={ i18n.addSynchro } />
            </Tabs>
            {tab === TRATEMENT_INDEX && (
                <Card sx={{ padding: '0.5rem', borderRadius: '0 0 5px 5px' }}>
                    <CodeChoicePanel
                        {...params}
                    />
                    <StyledFieldSet>
                        <StyledLegend>
                            <StyledSpan>{i18n.hydroStation}</StyledSpan>
                        </StyledLegend>
                        <Stack spacing={6}>
                            <TraitementImportStartCard
                                {...params}
                                logo={hydroPortailLogo}
                                type={IMPORT_TYPE.HYDRO_PORTAIL}
                                title={i18n.hydroPortail}
                            />
                            <TraitementImportStartCard
                                {...params}
                                logo={EtiagesOndeLogo}
                                type={IMPORT_TYPE.LOW_WATER_ONDE}
                                title={i18n.lowWaterOnde}
                            />
                            <TraitementImportStartCard
                                {...params}
                                logo={shomLogo}
                                type={IMPORT_TYPE.TIDE_GAUGE}
                                title={i18n.tidegauge}
                            />
                        </Stack>
                    </StyledFieldSet>
                    <StyledFieldSet>
                        <StyledLegend>
                            <StyledSpan>{i18n.piezometry}</StyledSpan>
                        </StyledLegend>
                        <Stack>
                            <TraitementImportStartCard
                                {...params}
                                logo={adesLogo}
                                type={IMPORT_TYPE.PIEZO_PORTAIL}
                                title={i18n.ades}
                            />
                        </Stack>
                    </StyledFieldSet>
                    <StyledFieldSet>
                        <StyledLegend>
                            <StyledSpan>{i18n.pluviometry}</StyledSpan>
                        </StyledLegend>
                        <Stack spacing={6}>
                            <TraitementImportStartCard
                                {...params}
                                logo={meteofranceLogo}
                                type={IMPORT_TYPE.PLUVIO_PORTAIL}
                                title={i18n.meteofrance}
                            />
                            <TraitementImportStartCard
                                {...params}
                                logo={era5Logo}
                                type={IMPORT_TYPE.ERA5}
                                title={i18n.ERA5}
                            />
                            {choiceTypeCode === CITIES &&
                        <TraitementImportStartCard
                            {...params}
                            logo={pluvioempriseLogo}
                            type={IMPORT_TYPE.PLUVIO_EMPRISE}
                            title={i18n.pluvioAreaJob}
                        />
                            }
                            <TraitementImportStartCard
                                {...params}
                                logo={safranLogo}
                                type={IMPORT_TYPE.METEO_FRANCE_RADAR}
                                title={i18n.SAFRAN}
                            />
                        </Stack>
                    </StyledFieldSet>
                    <StyledFieldSet>
                        <StyledLegend>
                            <StyledSpan>{i18n.quality}</StyledSpan>
                        </StyledLegend>
                        <Stack spacing={6}>
                            <TraitementImportStartCard
                                {...params}
                                logo = {adesLogo}
                                type = {IMPORT_TYPE.ADES_QUALITO}
                                title = {i18n.ades}
                            />
                            <TraitementImportStartCard
                                {...params}
                                logo = {naiadesLogo}
                                type = {IMPORT_TYPE.NAIADES}
                                title = {i18n.naïades}
                            />
                            <TraitementImportStartCard
                                {...params}
                                logo = {orobnatLogo}
                                type = {IMPORT_TYPE.OROBNAT}
                                title = {i18n.orobnat}
                                orobnatIsUsed={true}
                            />
                        </Stack>
                    </StyledFieldSet>
                    <Grid container mt={1} spacing={4}>
                        <Grid offset={9}>
                            <Button
                                variant='contained'
                                startIcon={<NoteAddIcon/>}
                                disabled={typeStation.length < 1 || listCode.length < 1}
                                onClick={handleSaveAll}
                            >
                                {i18n.save}
                            </Button>
                        </Grid>
                        <Grid>
                            <Button
                                variant='contained'
                                startIcon={<PlayCircleFilledWhiteOutlinedIcon/>}
                                disabled={typeStation.length < 1 || listCode.length < 1}
                                onClick={handleStartAndSaveAll}
                            >
                                {`${i18n.save} / ${i18n.launch}`}
                            </Button>
                        </Grid>
                    </Grid>
                </Card>
            )}
            {tab === SYNCHRO_INDEX && (
                <Card sx={{ padding: '0.5rem', borderRadius: '0 0 5px 5px' }}>
                    <div style={{ display: 'grid', gap: 16 }}>
                        {activeJobs.map((data, index) => (
                            <TraitementSynchroStartCard
                                key={index}
                                {...data}
                                title={data.name}
                                insertAllDataBanq={data.parameters.filters?[0].insertAllDataBanq: false}
                                data={data}
                                params={paramsSynchro}
                            />
                        ))}
                    </div>
                </Card>
            )}
        </Grid>
    )
}


export default ImportStartApp
